export const StoryCard = ({
  count,
  action,
  backgroundImage,
  username,
  profilePic,
}: {
  count: number;
  action: string;
  backgroundImage: string;
  username?: string;
  profilePic?: string;
}) => {
  return (
    <div className="p-1 pointer-events-none select-none">
      <div
        className="shadow-md relative overflow-hidden rounded-lg bg-gray-800"
        style={{ height: "280px" }}
      >
        <div className="story-profile absolute top-2 left-2 z-10 flex items-center">
          {profilePic && (
            <img
              alt={username || ""}
              className="w-8 h-8 rounded-full border border-white/20"
              src={profilePic}
            />
          )}
          {username && (
            <span className="text-sm ml-2 text-white font-medium">
              {username}
            </span>
          )}
        </div>

        <div className="story-profile absolute bottom-10 right-5 text-end flex flex-col z-10">
          <small className="text-white">
            <strong>
              <span className="text-[1.65rem] leading-[1.75rem]">{count}</span>{" "}
              perfis
            </strong>
            <br />
            {action}
          </small>

          <div className="flex mt-2 items-center justify-end">
            <div className="flex mr-2">
              {Array.from({ length: 4 }).map((_, i) => (
                <div key={i} style={{ marginLeft: i > 0 ? "-8px" : "0" }}>
                  <div
                    className="w-7 h-7 rounded-full bg-gray-700 border-2 border-gray-900 flex items-center justify-center text-xs font-bold"
                    style={{
                      backgroundImage: `url(https://randomuser.me/api/portraits/${i % 2 ? "women" : "men"}/${i + 5}.jpg)`,
                      backgroundSize: "cover",
                    }}
                  >
                    {!i && "A"}
                  </div>
                </div>
              ))}
            </div>
            <svg
              width="24"
              height="24"
              viewBox="0 0 31 31"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M12.9167 7.75L20.6667 15.5L12.9167 23.25L11.1084 21.4417L17.05 15.5L11.1084 9.55833L12.9167 7.75Z"
                fill="#FEF7FF"
              ></path>
            </svg>
          </div>
        </div>

        <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-black/30"></div>

        {backgroundImage ? (
          <img
            className="story-activity-background w-full h-full object-cover"
            src={backgroundImage}
            alt="Story background"
          />
        ) : (
          <div className="w-full h-full bg-gradient-to-br from-purple-900 to-pink-800"></div>
        )}
      </div>
    </div>
  );
};
